import { useEffect, useRef } from "react";

export const PetriDish = () => {
  const ref = useRef(null);

  useEffect(() => {
    const c = ref.current;
    const g = c.getContext("2d");
    let raf;
    let start = null;
    const colonies = Array.from({ length: 28 }, (_, i) => {
      const a = Math.random() * 6.28;
      const d = Math.sqrt(Math.random()) * 0.78;
      return { x: Math.cos(a) * d, y: Math.sin(a) * d, size: 0.03 + Math.random() * 0.08, delay: i * 0.12, seed: Math.random() * 9 };
    });
    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      c.width = c.clientWidth * dpr;
      c.height = c.clientHeight * dpr;
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = (ms) => {
      if (start === null) start = ms;
      const t = (ms - start) / 1000;
      const w = c.clientWidth;
      const h = c.clientHeight;
      const cx = w / 2;
      const cy = h / 2;
      const Rd = Math.min(w, h) * 0.38 * Math.min(1, 0.6 + t * 0.8);
      g.clearRect(0, 0, w, h);

      g.save();
      g.shadowColor = "rgba(0,255,136,0.6)";
      g.shadowBlur = 40 + Math.sin(t * 2) * 15;
      g.beginPath();
      g.arc(cx, cy, Rd * 1.06, 0, 6.28);
      g.strokeStyle = "rgba(0,240,255,0.7)";
      g.lineWidth = 3;
      g.stroke();
      g.restore();

      const agar = g.createRadialGradient(cx, cy, 0, cx, cy, Rd);
      agar.addColorStop(0, "rgba(0,255,136,0.16)");
      agar.addColorStop(1, "rgba(0,40,40,0.55)");
      g.fillStyle = agar;
      g.beginPath();
      g.arc(cx, cy, Rd, 0, 6.28);
      g.fill();

      g.beginPath();
      g.arc(cx, cy, Rd * 0.98, 0, 6.28);
      g.strokeStyle = "rgba(240,246,252,0.25)";
      g.lineWidth = 1;
      g.stroke();

      for (let i = 0; i < 72; i++) {
        const a = (i / 72) * 6.28;
        const l = i % 6 ? 6 : 14;
        g.beginPath();
        g.moveTo(cx + Math.cos(a) * Rd * 1.1, cy + Math.sin(a) * Rd * 1.1);
        g.lineTo(cx + Math.cos(a) * (Rd * 1.1 + l), cy + Math.sin(a) * (Rd * 1.1 + l));
        g.strokeStyle = "rgba(0,240,255,0.4)";
        g.stroke();
      }

      colonies.forEach((col) => {
        const grow = Math.min(1, Math.max(0, (t - col.delay) / 3));
        if (!grow) return;
        const r = col.size * Rd * grow * (1 + 0.1 * Math.sin(t * 2 + col.seed));
        const x = cx + col.x * Rd;
        const y = cy + col.y * Rd;
        g.save();
        g.shadowColor = "rgba(170,60,255,0.9)";
        g.shadowBlur = 18;
        g.beginPath();
        for (let k = 0; k <= 30; k++) {
          const a = (k / 30) * 6.28;
          const rr = r * (1 + 0.15 * Math.sin(a * 4 + t * 1.5 + col.seed));
          const px = x + Math.cos(a) * rr;
          const py = y + Math.sin(a) * rr;
          k ? g.lineTo(px, py) : g.moveTo(px, py);
        }
        g.fillStyle = "#030006";
        g.fill();
        g.restore();
      });

      const sweep = t * 1.4;
      g.save();
      g.beginPath();
      g.moveTo(cx, cy);
      g.arc(cx, cy, Rd, sweep, sweep + 0.5);
      g.closePath();
      g.fillStyle = "rgba(0,240,255,0.12)";
      g.fill();
      g.beginPath();
      g.moveTo(cx, cy);
      g.lineTo(cx + Math.cos(sweep + 0.5) * Rd, cy + Math.sin(sweep + 0.5) * Rd);
      g.strokeStyle = "rgba(0,240,255,0.8)";
      g.lineWidth = 1.5;
      g.stroke();
      g.restore();

      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} data-testid="petri-dish-canvas" className="absolute inset-0 w-full h-full" />;
};
